import React from 'react';

interface RequiredIconProps {
  isInvalid: boolean;
}

const RequiredIcon: React.FC<RequiredIconProps> = (data) => {
  const { isInvalid } = data;

  return (
    <span className={isInvalid ? 'text-danger' : ''}>*</span>
  );
};

export default RequiredIcon;
